/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
export default {
  af: 'Afrikaans',
  'af-NA': 'Afrikaans (Namibia)',
  'af-ZA': 'Afrikaans (South Africa)',
  ak: 'Akan',
  'ak-GH': 'Akan (Ghana)',
  am: 'Amharic',
  'am-ET': 'Amharic (Ethiopia)',
  ar: 'Arabic',
  'ar-AE': 'Arabic (United Arab Emirates)',
  'ar-BH': 'Arabic (Bahrain)',
  'ar-DJ': 'Arabic (Djibouti)',
  'ar-DZ': 'Arabic (Algeria)',
  'ar-EG': 'Arabic (Egypt)',
  'ar-EH': 'Arabic (Western Sahara)',
  'ar-ER': 'Arabic (Eritrea)',
  'ar-IL': 'Arabic (Israel)',
  'ar-IQ': 'Arabic (Iraq)',
  'ar-JO': 'Arabic (Jordan)',
  'ar-KM': 'Arabic (Comoros)',
  'ar-KW': 'Arabic (Kuwait)',
  'ar-LB': 'Arabic (Lebanon)',
  'ar-LY': 'Arabic (Libya)',
  'ar-MA': 'Arabic (Morocco)',
  'ar-MR': 'Arabic (Mauritania)',
  'ar-OM': 'Arabic (Oman)',
  'ar-PS': 'Arabic (Palestinian Territories)',
  'ar-QA': 'Arabic (Qatar)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ar-SD': 'Arabic (Sudan)',
  'ar-SO': 'Arabic (Somalia)',
  'ar-SS': 'Arabic (South Sudan)',
  'ar-SY': 'Arabic (Syria)',
  'ar-TD': 'Arabic (Chad)',
  'ar-TN': 'Arabic (Tunisia)',
  'ar-YE': 'Arabic (Yemen)',
  as: 'Assamese',
  'as-IN': 'Assamese (India)',
  az: 'Azerbaijani',
  'az-AZ': 'Azerbaijani (Azerbaijan)',
  'az-Cyrl': 'Azerbaijani (Cyrillic)',
  'az-Cyrl_AZ': 'Azerbaijani (Cyrillic, Azerbaijan)',
  'az-Latn': 'Azerbaijani (Latin)',
  'az-Latn_AZ': 'Azerbaijani (Latin, Azerbaijan)',
  be: 'Belarusian',
  'be-BY': 'Belarusian (Belarus)',
  bg: 'Bulgarian',
  'bg-BG': 'Bulgarian (Bulgaria)',
  bm: 'Bambara',
  'bm-Latn': 'Bambara (Latin)',
  'bm-Latn_ML': 'Bambara (Latin, Mali)',
  bn: 'Bengali',
  'bn-BD': 'Bengali (Bangladesh)',
  'bn-IN': 'Bengali (India)',
  bo: 'Tibetan',
  'bo-CN': 'Tibetan (China)',
  'bo-IN': 'Tibetan (India)',
  br: 'Breton',
  'br-FR': 'Breton (France)',
  bs: 'Bosnian',
  'bs-BA': 'Bosnian (Bosnia & Herzegovina)',
  'bs-Cyrl': 'Bosnian (Cyrillic)',
  'bs-Cyrl_BA': 'Bosnian (Cyrillic, Bosnia & Herzegovina)',
  'bs-Latn': 'Bosnian (Latin)',
  'bs-Latn_BA': 'Bosnian (Latin, Bosnia & Herzegovina)',
  ca: 'Catalan',
  'ca-AD': 'Catalan (Andorra)',
  'ca-ES': 'Catalan (Spain)',
  'ca-FR': 'Catalan (France)',
  'ca-IT': 'Catalan (Italy)',
  cs: 'Czech',
  'cs-CZ': 'Czech (Czech Republic)',
  cy: 'Welsh',
  'cy-GB': 'Welsh (United Kingdom)',
  da: 'Danish',
  'da-DK': 'Danish (Denmark)',
  'da-GL': 'Danish (Greenland)',
  de: 'German',
  'de-AT': 'German (Austria)',
  'de-BE': 'German (Belgium)',
  'de-CH': 'German (Switzerland)',
  'de-DE': 'German (Germany)',
  'de-LI': 'German (Liechtenstein)',
  'de-LU': 'German (Luxembourg)',
  dz: 'Dzongkha',
  'dz-BT': 'Dzongkha (Bhutan)',
  ee: 'Ewe',
  'ee-GH': 'Ewe (Ghana)',
  'ee-TG': 'Ewe (Togo)',
  el: 'Greek',
  'el-CY': 'Greek (Cyprus)',
  'el-GR': 'Greek (Greece)',
  en: 'English',
  'en-AG': 'English (Antigua & Barbuda)',
  'en-AI': 'English (Anguilla)',
  'en-AS': 'English (American Samoa)',
  'en-AU': 'English (Australia)',
  'en-BB': 'English (Barbados)',
  'en-BE': 'English (Belgium)',
  'en-BM': 'English (Bermuda)',
  'en-BS': 'English (Bahamas)',
  'en-BW': 'English (Botswana)',
  'en-BZ': 'English (Belize)',
  'en-CA': 'English (Canada)',
  'en-CC': 'English (Cocos (Keeling) Islands)',
  'en-CK': 'English (Cook Islands)',
  'en-CM': 'English (Cameroon)',
  'en-CX': 'English (Christmas Island)',
  'en-DG': 'English (Diego Garcia)',
  'en-DM': 'English (Dominica)',
  'en-ER': 'English (Eritrea)',
  'en-FJ': 'English (Fiji)',
  'en-FK': 'English (Falkland Islands)',
  'en-FM': 'English (Micronesia)',
  'en-GB': 'English (United Kingdom)',
  'en-GD': 'English (Grenada)',
  'en-GG': 'English (Guernsey)',
  'en-GH': 'English (Ghana)',
  'en-GI': 'English (Gibraltar)',
  'en-GM': 'English (Gambia)',
  'en-GU': 'English (Guam)',
  'en-GY': 'English (Guyana)',
  'en-HK': 'English (Hong Kong SAR China)',
  'en-IE': 'English (Ireland)',
  'en-IM': 'English (Isle of Man)',
  'en-IN': 'English (India)',
  'en-IO': 'English (British Indian Ocean Territory)',
  'en-JE': 'English (Jersey)',
  'en-JM': 'English (Jamaica)',
  'en-KE': 'English (Kenya)',
  'en-KI': 'English (Kiribati)',
  'en-KN': 'English (St. Kitts & Nevis)',
  'en-KY': 'English (Cayman Islands)',
  'en-LC': 'English (St. Lucia)',
  'en-LR': 'English (Liberia)',
  'en-LS': 'English (Lesotho)',
  'en-MG': 'English (Madagascar)',
  'en-MH': 'English (Marshall Islands)',
  'en-MO': 'English (Macau SAR China)',
  'en-MP': 'English (Northern Mariana Islands)',
  'en-MS': 'English (Montserrat)',
  'en-MT': 'English (Malta)',
  'en-MU': 'English (Mauritius)',
  'en-MW': 'English (Malawi)',
  'en-MY': 'English (Malaysia)',
  'en-NA': 'English (Namibia)',
  'en-NF': 'English (Norfolk Island)',
  'en-NG': 'English (Nigeria)',
  'en-NR': 'English (Nauru)',
  'en-NU': 'English (Niue)',
  'en-NZ': 'English (New Zealand)',
  'en-PG': 'English (Papua New Guinea)',
  'en-PH': 'English (Philippines)',
  'en-PK': 'English (Pakistan)',
  'en-PN': 'English (Pitcairn Islands)',
  'en-PR': 'English (Puerto Rico)',
  'en-PW': 'English (Palau)',
  'en-RW': 'English (Rwanda)',
  'en-SB': 'English (Solomon Islands)',
  'en-SC': 'English (Seychelles)',
  'en-SD': 'English (Sudan)',
  'en-SG': 'English (Singapore)',
  'en-SH': 'English (St. Helena)',
  'en-SL': 'English (Sierra Leone)',
  'en-SS': 'English (South Sudan)',
  'en-SX': 'English (Sint Maarten)',
  'en-SZ': 'English (Swaziland)',
  'en-TC': 'English (Turks & Caicos Islands)',
  'en-TK': 'English (Tokelau)',
  'en-TO': 'English (Tonga)',
  'en-TT': 'English (Trinidad & Tobago)',
  'en-TV': 'English (Tuvalu)',
  'en-TZ': 'English (Tanzania)',
  'en-UG': 'English (Uganda)',
  'en-UM': 'English (U.S. Outlying Islands)',
  'en-US': 'English (United States)',
  'en-VC': 'English (St. Vincent & Grenadines)',
  'en-VG': 'English (British Virgin Islands)',
  'en-VI': 'English (U.S. Virgin Islands)',
  'en-VU': 'English (Vanuatu)',
  'en-WS': 'English (Samoa)',
  'en-ZA': 'English (South Africa)',
  'en-ZM': 'English (Zambia)',
  'en-ZW': 'English (Zimbabwe)',
  eo: 'Esperanto',
  es: 'Spanish',
  'es-AR': 'Spanish (Argentina)',
  'es-BO': 'Spanish (Bolivia)',
  'es-CL': 'Spanish (Chile)',
  'es-CO': 'Spanish (Colombia)',
  'es-CR': 'Spanish (Costa Rica)',
  'es-CU': 'Spanish (Cuba)',
  'es-DO': 'Spanish (Dominican Republic)',
  'es-EA': 'Spanish (Ceuta & Melilla)',
  'es-EC': 'Spanish (Ecuador)',
  'es-ES': 'Spanish (Spain)',
  'es-GQ': 'Spanish (Equatorial Guinea)',
  'es-GT': 'Spanish (Guatemala)',
  'es-HN': 'Spanish (Honduras)',
  'es-IC': 'Spanish (Canary Islands)',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish (Nicaragua)',
  'es-PA': 'Spanish (Panama)',
  'es-PE': 'Spanish (Peru)',
  'es-PH': 'Spanish (Philippines)',
  'es-PR': 'Spanish (Puerto Rico)',
  'es-PY': 'Spanish (Paraguay)',
  'es-SV': 'Spanish (El Salvador)',
  'es-US': 'Spanish (United States)',
  'es-UY': 'Spanish (Uruguay)',
  'es-VE': 'Spanish (Venezuela)',
  et: 'Estonian',
  'et-EE': 'Estonian (Estonia)',
  eu: 'Basque',
  'eu-ES': 'Basque (Spain)',
  fa: 'Persian',
  'fa-AF': 'Persian (Afghanistan)',
  'fa-IR': 'Persian (Iran)',
  ff: 'Fulah',
  'ff-CM': 'Fulah (Cameroon)',
  'ff-GN': 'Fulah (Guinea)',
  'ff-MR': 'Fulah (Mauritania)',
  'ff-SN': 'Fulah (Senegal)',
  fi: 'Finnish',
  'fi-FI': 'Finnish (Finland)',
  fo: 'Faroese',
  'fo-FO': 'Faroese (Faroe Islands)',
  fr: 'French',
  'fr-BE': 'French (Belgium)',
  'fr-BF': 'French (Burkina Faso)',
  'fr-BI': 'French (Burundi)',
  'fr-BJ': 'French (Benin)',
  'fr-BL': 'French (St. Barthélemy)',
  'fr-CA': 'French (Canada)',
  'fr-CD': 'French (Congo - Kinshasa)',
  'fr-CF': 'French (Central African Republic)',
  'fr-CG': 'French (Congo - Brazzaville)',
  'fr-CH': 'French (Switzerland)',
  'fr-CI': 'French (Côte d’Ivoire)',
  'fr-CM': 'French (Cameroon)',
  'fr-DJ': 'French (Djibouti)',
  'fr-DZ': 'French (Algeria)',
  'fr-FR': 'French (France)',
  'fr-GA': 'French (Gabon)',
  'fr-GF': 'French (French Guiana)',
  'fr-GN': 'French (Guinea)',
  'fr-GP': 'French (Guadeloupe)',
  'fr-GQ': 'French (Equatorial Guinea)',
  'fr-HT': 'French (Haiti)',
  'fr-KM': 'French (Comoros)',
  'fr-LU': 'French (Luxembourg)',
  'fr-MA': 'French (Morocco)',
  'fr-MC': 'French (Monaco)',
  'fr-MF': 'French (St. Martin)',
  'fr-MG': 'French (Madagascar)',
  'fr-ML': 'French (Mali)',
  'fr-MQ': 'French (Martinique)',
  'fr-MR': 'French (Mauritania)',
  'fr-MU': 'French (Mauritius)',
  'fr-NC': 'French (New Caledonia)',
  'fr-NE': 'French (Niger)',
  'fr-PF': 'French (French Polynesia)',
  'fr-PM': 'French (St. Pierre & Miquelon)',
  'fr-RE': 'French (Réunion)',
  'fr-RW': 'French (Rwanda)',
  'fr-SC': 'French (Seychelles)',
  'fr-SN': 'French (Senegal)',
  'fr-SY': 'French (Syria)',
  'fr-TD': 'French (Chad)',
  'fr-TG': 'French (Togo)',
  'fr-TN': 'French (Tunisia)',
  'fr-VU': 'French (Vanuatu)',
  'fr-WF': 'French (Wallis & Futuna)',
  'fr-YT': 'French (Mayotte)',
  fy: 'Western Frisian',
  'fy-NL': 'Western Frisian (Netherlands)',
  ga: 'Irish',
  'ga-IE': 'Irish (Ireland)',
  gd: 'Scottish Gaelic',
  'gd-GB': 'Scottish Gaelic (United Kingdom)',
  gl: 'Galician',
  'gl-ES': 'Galician (Spain)',
  gu: 'Gujarati',
  'gu-IN': 'Gujarati (India)',
  gv: 'Manx',
  'gv-IM': 'Manx (Isle of Man)',
  ha: 'Hausa',
  'ha-GH': 'Hausa (Ghana)',
  'ha-Latn': 'Hausa (Latin)',
  'ha-Latn_GH': 'Hausa (Latin, Ghana)',
  'ha-Latn_NE': 'Hausa (Latin, Niger)',
  'ha-Latn_NG': 'Hausa (Latin, Nigeria)',
  'ha-NE': 'Hausa (Niger)',
  'ha-NG': 'Hausa (Nigeria)',
  he: 'Hebrew',
  'he-IL': 'Hebrew (Israel)',
  hi: 'Hindi',
  'hi-IN': 'Hindi (India)',
  hr: 'Croatian',
  'hr-BA': 'Croatian (Bosnia & Herzegovina)',
  'hr-HR': 'Croatian (Croatia)',
  hu: 'Hungarian',
  'hu-HU': 'Hungarian (Hungary)',
  hy: 'Armenian',
  'hy-AM': 'Armenian (Armenia)',
  id: 'Indonesian',
  'id-ID': 'Indonesian (Indonesia)',
  ig: 'Igbo',
  'ig-NG': 'Igbo (Nigeria)',
  ii: 'Sichuan Yi',
  'ii-CN': 'Sichuan Yi (China)',
  is: 'Icelandic',
  'is-IS': 'Icelandic (Iceland)',
  it: 'Italian',
  'it-CH': 'Italian (Switzerland)',
  'it-IT': 'Italian (Italy)',
  'it-SM': 'Italian (San Marino)',
  ja: 'Japanese',
  'ja-JP': 'Japanese (Japan)',
  ka: 'Georgian',
  'ka-GE': 'Georgian (Georgia)',
  ki: 'Kikuyu',
  'ki-KE': 'Kikuyu (Kenya)',
  kk: 'Kazakh',
  'kk-Cyrl': 'Kazakh (Cyrillic)',
  'kk-Cyrl_KZ': 'Kazakh (Cyrillic, Kazakhstan)',
  'kk-KZ': 'Kazakh (Kazakhstan)',
  kl: 'Kalaallisut',
  'kl-GL': 'Kalaallisut (Greenland)',
  km: 'Khmer',
  'km-KH': 'Khmer (Cambodia)',
  kn: 'Kannada',
  'kn-IN': 'Kannada (India)',
  ko: 'Korean',
  'ko-KP': 'Korean (North Korea)',
  'ko-KR': 'Korean (South Korea)',
  ks: 'Kashmiri',
  'ks-Arab': 'Kashmiri (Arabic)',
  'ks-Arab_IN': 'Kashmiri (Arabic, India)',
  'ks-IN': 'Kashmiri (India)',
  kw: 'Cornish',
  'kw-GB': 'Cornish (United Kingdom)',
  ky: 'Kyrgyz',
  'ky-Cyrl': 'Kyrgyz (Cyrillic)',
  'ky-Cyrl_KG': 'Kyrgyz (Cyrillic, Kyrgyzstan)',
  'ky-KG': 'Kyrgyz (Kyrgyzstan)',
  lb: 'Luxembourgish',
  'lb-LU': 'Luxembourgish (Luxembourg)',
  lg: 'Ganda',
  'lg-UG': 'Ganda (Uganda)',
  ln: 'Lingala',
  'ln-AO': 'Lingala (Angola)',
  'ln-CD': 'Lingala (Congo - Kinshasa)',
  'ln-CF': 'Lingala (Central African Republic)',
  'ln-CG': 'Lingala (Congo - Brazzaville)',
  lo: 'Lao',
  'lo-LA': 'Lao (Laos)',
  lt: 'Lithuanian',
  'lt-LT': 'Lithuanian (Lithuania)',
  lu: 'Luba-Katanga',
  'lu-CD': 'Luba-Katanga (Congo - Kinshasa)',
  lv: 'Latvian',
  'lv-LV': 'Latvian (Latvia)',
  mg: 'Malagasy',
  'mg-MG': 'Malagasy (Madagascar)',
  mk: 'Macedonian',
  'mk-MK': 'Macedonian (Macedonia)',
  ml: 'Malayalam',
  'ml-IN': 'Malayalam (India)',
  mn: 'Mongolian',
  'mn-Cyrl': 'Mongolian (Cyrillic)',
  'mn-Cyrl_MN': 'Mongolian (Cyrillic, Mongolia)',
  'mn-MN': 'Mongolian (Mongolia)',
  mr: 'Marathi',
  'mr-IN': 'Marathi (India)',
  ms: 'Malay',
  'ms-BN': 'Malay (Brunei)',
  'ms-Latn': 'Malay (Latin)',
  'ms-Latn_BN': 'Malay (Latin, Brunei)',
  'ms-Latn_MY': 'Malay (Latin, Malaysia)',
  'ms-Latn_SG': 'Malay (Latin, Singapore)',
  'ms-MY': 'Malay (Malaysia)',
  'ms-SG': 'Malay (Singapore)',
  mt: 'Maltese',
  'mt-MT': 'Maltese (Malta)',
  my: 'Burmese',
  'my-MM': 'Burmese (Myanmar (Burma))',
  nb: 'Norwegian Bokmål',
  'nb-NO': 'Norwegian Bokmål (Norway)',
  'nb-SJ': 'Norwegian Bokmål (Svalbard & Jan Mayen)',
  nd: 'North Ndebele',
  'nd-ZW': 'North Ndebele (Zimbabwe)',
  ne: 'Nepali',
  'ne-IN': 'Nepali (India)',
  'ne-NP': 'Nepali (Nepal)',
  nl: 'Dutch',
  'nl-AW': 'Dutch (Aruba)',
  'nl-BE': 'Dutch (Belgium)',
  'nl-BQ': 'Dutch (Caribbean Netherlands)',
  'nl-CW': 'Dutch (Curaçao)',
  'nl-NL': 'Dutch (Netherlands)',
  'nl-SR': 'Dutch (Suriname)',
  'nl-SX': 'Dutch (Sint Maarten)',
  nn: 'Norwegian Nynorsk',
  'nn-NO': 'Norwegian Nynorsk (Norway)',
  no: 'Norwegian',
  'no-NO': 'Norwegian (Norway)',
  om: 'Oromo',
  'om-ET': 'Oromo (Ethiopia)',
  'om-KE': 'Oromo (Kenya)',
  or: 'Oriya',
  'or-IN': 'Oriya (India)',
  os: 'Ossetic',
  'os-GE': 'Ossetic (Georgia)',
  'os-RU': 'Ossetic (Russia)',
  pa: 'Punjabi',
  'pa-Arab': 'Punjabi (Arabic)',
  'pa-Arab_PK': 'Punjabi (Arabic, Pakistan)',
  'pa-Guru': 'Punjabi (Gurmukhi)',
  'pa-Guru_IN': 'Punjabi (Gurmukhi, India)',
  'pa-IN': 'Punjabi (India)',
  'pa-PK': 'Punjabi (Pakistan)',
  pl: 'Polish',
  'pl-PL': 'Polish (Poland)',
  ps: 'Pashto',
  'ps-AF': 'Pashto (Afghanistan)',
  pt: 'Portuguese',
  'pt-AO': 'Portuguese (Angola)',
  'pt-BR': 'Portuguese (Brazilian)',
  'pt-CV': 'Portuguese (Cape Verde)',
  'pt-GW': 'Portuguese (Guinea-Bissau)',
  'pt-MO': 'Portuguese (Macau SAR China)',
  'pt-MZ': 'Portuguese (Mozambique)',
  'pt-PT': 'Portuguese (Portugal)',
  'pt-ST': 'Portuguese (São Tomé & Príncipe)',
  'pt-TL': 'Portuguese (Timor-Leste)',
  qu: 'Quechua',
  'qu-BO': 'Quechua (Bolivia)',
  'qu-EC': 'Quechua (Ecuador)',
  'qu-PE': 'Quechua (Peru)',
  rm: 'Romansh',
  'rm-CH': 'Romansh (Switzerland)',
  rn: 'Rundi',
  'rn-BI': 'Rundi (Burundi)',
  ro: 'Romanian',
  'ro-MD': 'Romanian (Moldova)',
  'ro-RO': 'Romanian (Romania)',
  ru: 'Russian',
  'ru-BY': 'Russian (Belarus)',
  'ru-KG': 'Russian (Kyrgyzstan)',
  'ru-KZ': 'Russian (Kazakhstan)',
  'ru-MD': 'Russian (Moldova)',
  'ru-RU': 'Russian (Russia)',
  'ru-UA': 'Russian (Ukraine)',
  rw: 'Kinyarwanda',
  'rw-RW': 'Kinyarwanda (Rwanda)',
  se: 'Northern Sami',
  'se-FI': 'Northern Sami (Finland)',
  'se-NO': 'Northern Sami (Norway)',
  'se-SE': 'Northern Sami (Sweden)',
  sg: 'Sango',
  'sg-CF': 'Sango (Central African Republic)',
  sh: 'Serbo-Croatian',
  'sh-BA': 'Serbo-Croatian (Bosnia & Herzegovina)',
  si: 'Sinhala',
  'si-LK': 'Sinhala (Sri Lanka)',
  sk: 'Slovak',
  'sk-SK': 'Slovak (Slovakia)',
  sl: 'Slovenian',
  'sl-SI': 'Slovenian (Slovenia)',
  sn: 'Shona',
  'sn-ZW': 'Shona (Zimbabwe)',
  so: 'Somali',
  'so-DJ': 'Somali (Djibouti)',
  'so-ET': 'Somali (Ethiopia)',
  'so-KE': 'Somali (Kenya)',
  'so-SO': 'Somali (Somalia)',
  sq: 'Albanian',
  'sq-AL': 'Albanian (Albania)',
  'sq-MK': 'Albanian (Macedonia)',
  'sq-XK': 'Albanian (Kosovo)',
  sr: 'Serbian',
  'sr-BA': 'Serbian (Bosnia & Herzegovina)',
  'sr-Cyrl': 'Serbian (Cyrillic)',
  'sr-Cyrl_BA': 'Serbian (Cyrillic, Bosnia & Herzegovina)',
  'sr-Cyrl_ME': 'Serbian (Cyrillic, Montenegro)',
  'sr-Cyrl_RS': 'Serbian (Cyrillic, Serbia)',
  'sr-Cyrl_XK': 'Serbian (Cyrillic, Kosovo)',
  'sr-Latn': 'Serbian (Latin)',
  'sr-Latn_BA': 'Serbian (Latin, Bosnia & Herzegovina)',
  'sr-Latn_ME': 'Serbian (Latin, Montenegro)',
  'sr-Latn_RS': 'Serbian (Latin, Serbia)',
  'sr-Latn_XK': 'Serbian (Latin, Kosovo)',
  'sr-ME': 'Serbian (Montenegro)',
  'sr-RS': 'Serbian (Serbia)',
  'sr-XK': 'Serbian (Kosovo)',
  sv: 'Swedish',
  'sv-AX': 'Swedish (Åland Islands)',
  'sv-FI': 'Swedish (Finland)',
  'sv-SE': 'Swedish (Sweden)',
  sw: 'Swahili',
  'sw-KE': 'Swahili (Kenya)',
  'sw-TZ': 'Swahili (Tanzania)',
  'sw-UG': 'Swahili (Uganda)',
  ta: 'Tamil',
  'ta-IN': 'Tamil (India)',
  'ta-LK': 'Tamil (Sri Lanka)',
  'ta-MY': 'Tamil (Malaysia)',
  'ta-SG': 'Tamil (Singapore)',
  te: 'Telugu',
  'te-IN': 'Telugu (India)',
  th: 'Thai',
  'th-TH': 'Thai (Thailand)',
  ti: 'Tigrinya',
  'ti-ER': 'Tigrinya (Eritrea)',
  'ti-ET': 'Tigrinya (Ethiopia)',
  tl: 'Tagalog',
  'tl-PH': 'Tagalog (Philippines)',
  to: 'Tongan',
  'to-TO': 'Tongan (Tonga)',
  tr: 'Turkish',
  'tr-CY': 'Turkish (Cyprus)',
  'tr-TR': 'Turkish (Turkey)',
  ug: 'Uyghur',
  'ug-Arab': 'Uyghur (Arabic)',
  'ug-Arab_CN': 'Uyghur (Arabic, China)',
  'ug-CN': 'Uyghur (China)',
  uk: 'Ukrainian',
  'uk-UA': 'Ukrainian (Ukraine)',
  ur: 'Urdu',
  'ur-IN': 'Urdu (India)',
  'ur-PK': 'Urdu (Pakistan)',
  uz: 'Uzbek',
  'uz-AF': 'Uzbek (Afghanistan)',
  'uz-Arab': 'Uzbek (Arabic)',
  'uz-Arab_AF': 'Uzbek (Arabic, Afghanistan)',
  'uz-Cyrl': 'Uzbek (Cyrillic)',
  'uz-Cyrl_UZ': 'Uzbek (Cyrillic, Uzbekistan)',
  'uz-Latn': 'Uzbek (Latin)',
  'uz-Latn_UZ': 'Uzbek (Latin, Uzbekistan)',
  'uz-UZ': 'Uzbek (Uzbekistan)',
  vi: 'Vietnamese',
  'vi-VN': 'Vietnamese (Vietnam)',
  yi: 'Yiddish',
  yo: 'Yoruba',
  'yo-BJ': 'Yoruba (Benin)',
  'yo-NG': 'Yoruba (Nigeria)',
  zh: 'Chinese',
  'zh-CN': 'Chinese (China)',
  'zh-Hans': 'Chinese (Simplified)',
  'zh-Hans_CN': 'Chinese (Simplified, China)',
  'zh-Hans_HK': 'Chinese (Simplified, Hong Kong SAR China)',
  'zh-Hans_MO': 'Chinese (Simplified, Macau SAR China)',
  'zh-Hans_SG': 'Chinese (Simplified, Singapore)',
  'zh-Hant': 'Chinese (Traditional)',
  'zh-Hant_HK': 'Chinese (Traditional, Hong Kong SAR China)',
  'zh-Hant_MO': 'Chinese (Traditional, Macau SAR China)',
  'zh-Hant_TW': 'Chinese (Traditional, Taiwan)',
  'zh-HK': 'Chinese (Hong Kong SAR China)',
  'zh-MO': 'Chinese (Macau SAR China)',
  'zh-SG': 'Chinese (Singapore)',
  'zh-TW': 'Chinese (Taiwan)',
  zu: 'Zulu',
  'zu-ZA': 'Zulu (South Africa)',
} as Record<string, string>;
